module.exports = __webpack_public_path__ + "img/20190418_154809_002.085ff45a.jpg";